import StatusPill, { type Tone } from '@/components/console/status-pill';
import { humanize } from '@/lib/format';
import type { InvoiceStatus } from '@/types/platform';

const TONES: Record<InvoiceStatus, Tone> = {
  draft: 'neutral',
  open: 'info',
  paid: 'success',
  void: 'neutral',
  uncollectible: 'neutral',
};

const InvoiceStatusPill = ({ status }: { status: InvoiceStatus }) => {
  return <StatusPill tone={TONES[status]}>{humanize(status)}</StatusPill>;
};

export default InvoiceStatusPill;
